export default "__VITE_ASSET__xwPDRzsp__"